import React, { useEffect, useState } from "react";
import SearchImg from "../../../assets/user/images/search1.svg";
import Search from "../../../assets/user/images/search1.svg";
import UserImg from "../../../assets/user/images/user.png";
import DatePicker from "react-datepicker";
import RightArrow from "../../../assets/user/images/right-arow.png";
import "../../../../node_modules/react-datepicker/dist/react-datepicker.css";
import { Link, useNavigate } from "react-router-dom";
import bgcoupon from "../../../assets/admin/images/couponbg.svg";
import Loader from "../../../layouts/loader/Loader";
import { routes } from "../../../utlis/user/routes.utlis";
import { api } from "../../../utlis/user/api.utlis";
import toast from "react-hot-toast";
import ApiService from "../../../core/services/ApiService";
import NoImage from "../../../assets/admin/images/no-image.jpg";
import NoData from "../../../assets/admin/images/no-data-found.svg";
import {
  communityLIMIT,
  totalPageCalculator,
} from "../../../utlis/common.utlis";
import { Modal, ModalBody } from "react-bootstrap";
import moment from "moment";
import { encode } from "base-64";

const CouponList = () => {
  const navigate = useNavigate();
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [total, setTotal] = useState(0);
  const [loyaltyId, setLoyaltyId] = useState(1);
  const [pageNum, setPageNum] = useState(1);
  const [startDate, setStartDate] = useState(null);

  const getCouponList = async (api) => {
    setLoading(true);
    const response = await ApiService.getAPIWithAccessToken(api);
    // console.log("coupon listing => ", response.data);
    if (response.data.status && response.data.statusCode === 200) {
      setList(response.data.data.coupons);
      setTotal(response.data.data.total);
    } else setList([]);
    setLoading(false);
  };

  const handleFilter = (e, date = null) => {
    e.persist();
    let name = "";
    if (e.target.name === "name") name = e.target.value;
    if (date != null && date != undefined && date != "")
      date = moment(date).format("MM-DD-yyyy");
    else date = "";
    getCouponList(
      api.loyaltyCouponList +
        `?page=${pageNum}&limit=${communityLIMIT}&loyalty_type=${loyaltyId}&search=${name}&date=${date}`
    );
  };

  const handleCopy = (text) => {
    navigator.clipboard
      .writeText(text)
      .then(() => {
        toast.success("Code Copied!");
      })
      .catch((err) => {
        toast.success("Failed to copy!");
      });
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    getCouponList(
      api.loyaltyCouponList +
        `?page=${pageNum}&limit=${communityLIMIT}&loyalty_type=${loyaltyId}`
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageNum, loyaltyId]);

  return (
    <>
      {loading ? <Loader /> : null}
      <div className="main-wrapper">
        <div className="container">
          <div className="care-loyalty-section">
            <div className="care-loyalty-nav">
              <ul>
                <li className={loyaltyId == 1 ? "active" : ""}>
                  <Link
                    onClick={() => {
                      setLoyaltyId(1);
                      setPageNum(1);
                    }}
                    to=""
                  >
                    Offer & Discounts
                  </Link>
                </li>
                <li className={loyaltyId == 2 ? "active" : ""}>
                  <Link
                    onClick={() => {
                      setLoyaltyId(2);
                      setPageNum(1);
                    }}
                    to=""
                  >
                    Subscription Plans
                  </Link>
                </li>
                <li className={loyaltyId == 3 ? "active" : ""}>
                  <Link
                    onClick={() => {
                      setLoyaltyId(3);
                      setPageNum(1);
                    }}
                    to=""
                  >
                    Giveaways
                  </Link>
                </li>
                <li className={loyaltyId == 4 ? "active" : ""}>
                  <Link
                    onClick={() => {
                      setLoyaltyId(4);
                      setPageNum(1);
                    }}
                    to=""
                  >
                    Contests
                  </Link>
                </li>
              </ul>
            </div>

            <div className="care-loyalty-content">
              <div className="care-title-header">
                <h2 className="heading-title">Care Loyalty</h2>
                <div className="search-filter wd50">
                  <div className="row g-2">
                    <div className="col-md-4">
                      <div className="form-group">
                        {/* <DatePicker
                          toggleCalendarOnIconClick
                          showIcon
                          dateFormat={"MM-dd-yyyy"}
                          selected={startDate}
                          onChange={(date, e) => {
                            setStartDate(date);
                            handleFilter(e, date);
                          }}
                          className="form-control"
                          style={{ padding: "15px 40px" }}
                          isClearable
                          autoComplete="off"
                          name="date"
                          placeholderText="Select Date"
                        /> */}
                      </div>
                    </div>
                    <div className="col-md-8">
                      <div className="form-group">
                        <div className="search-form-group">
                          <input
                            type="text"
                            name="name"
                            className="form-control"
                            placeholder="Search"
                            onChange={(e) => handleFilter(e)}
                          />
                          <span className="search-icon">
                            <img src={Search} />
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="row">
                {list.length !== 0 ? (
                  list.map((ele, indx) => {
                    return (
                      <div key={indx} className="col-md-4">
                        <div className="careloyalty-card">
                          <div className="coupon-card mb-0">
                            <div
                              className={
                                indx % 2
                                  ? "coupon-card-coupon-name"
                                  : "coupon-card-coupon-name-green"
                              }
                              style={{
                                backgroundImage: `url(${bgcoupon})`,
                                backgroundPosition: "center",
                                backgroundSize: "cover",
                                backgroundRepeat: "no-repeat",
                              }}
                            >
                              <h2>{ele.code ?? "NA"}</h2>
                            </div>
                            <span
                              style={{ padding: "5px 8px", cursor: "pointer", fontSize: "20px", borderRadius: "50%", background: "rgb(144 136 136)", position: "absolute", top: "2.5%", right: "2%" }}
                              onClick={() => handleCopy(ele.code ?? "")}
                              title="Copy"
                            >
                              <i style={{color: "#ffffff"}} className="fa fa-copy"></i>
                            </span>
                          </div>
                          <div className="careloyalty-cuppon-text">
                            <h2>{ele.title ?? "NA"}</h2>
                            <p className="mb-1">{ele.description ?? "NA"}</p>
                            <div className="cuppon-valid-date">
                              Offer valid till:{" "}
                              {moment(ele.valid_to).format("MM-DD-yyyy")}
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })
                ) : (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      margin: "5% 0",
                    }}
                  >
                    <img width={300} src={NoData} alt="" />
                  </div>
                )}
              </div>
              <div className="d-flex align-items-center justify-content-center mt-3">
                {list?.length !== 0 ? (
                  <div className="care-table-pagination">
                    <ul className="care-pagination">
                      {pageNum !== 1 && (
                        <li
                          className="disabled"
                          id="example_previous"
                          onClick={() => setPageNum(pageNum - 1)}
                        >
                          <Link
                            to=""
                            aria-controls="example"
                            data-dt-idx="0"
                            tabIndex="0"
                            className="page-link"
                          >
                            Previous
                          </Link>
                        </li>
                      )}

                      {totalPageCalculator(total, communityLIMIT).length === 1
                        ? null
                        : totalPageCalculator(total, communityLIMIT).map(
                            (pageNo, indx) => {
                              return (
                                <li
                                  className={pageNo === pageNum ? "active" : ""}
                                  key={indx}
                                  onClick={() => setPageNum(pageNo)}
                                >
                                  <Link to="" className="page-link">
                                    {pageNo}
                                  </Link>
                                </li>
                              );
                            }
                          )}

                      {pageNum !== Math.ceil(total / communityLIMIT) && (
                        <li
                          className="next"
                          id="example_next"
                          onClick={() => setPageNum(pageNum + 1)}
                        >
                          <Link
                            to=""
                            aria-controls="example"
                            data-dt-idx="7"
                            tabIndex="0"
                            className="page-link"
                          >
                            Next
                          </Link>
                        </li>
                      )}
                    </ul>
                  </div>
                ) : null}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CouponList;
